module.exports = __webpack_public_path__ + "static/burg2-11bab486783caa5a650a6d1dcdc538ac.jpg";